import Vue from 'vue';
import Vuex from 'vuex';
import { login, } from './modules/Login';
import { translations, } from './modules/Translations';
import { general, } from './modules/General';

Vue.use(Vuex);

export const store = new Vuex.Store({
	modules: {
		translations,
		login,
		general,
	},
});



// WEBPACK FOOTER //
// ./src/store/index.js